import qs from 'qs';
import { network } from 'services/network';

export const getIntegratedScheduleVersion = (params: { fileMetaDataId: number }) => {
    const querystring = qs.stringify(
        { fileMetaDataId: params.fileMetaDataId },
        { addQueryPrefix: true, skipNulls: true },
    );
    const url = `api/bo/getIntegratedScheduleVersion${querystring}`;
    return network.get(url).then((response) => response.data);
};
